<template>
    <div class="h-full w-full">
        Construyendo la seccion de: Logs
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>